import type { UITheme } from '@mentimeter/editor-tracking';
import Cookies from '@mentimeter/cookies';
// helper for getting the ui theme value for tracking purposes
export const getTrackedUITheme = (): UITheme => {
  const uiTheme = Cookies.get('ui-theme');
  switch (uiTheme) {
    case 'light':
    case 'dark':
      return uiTheme;
    case 'system-preference':
      if (window && window.matchMedia('(prefers-color-scheme: dark)').matches)
        return 'system-preference-dark';
      else return 'system-preference-light';
    default:
      return 'light';
  }
};
